import navigation from './modules/navigation';
import mobileStickyNav from './modules/mobileStickyNav';
import inlineVideo from './modules/inlineVideo';
import faqAccordion from './modules/faqAccordion';
import logoWallCarousel from './modules/logoWallCarousel';

// set up namespace
const spirax = window.spirax || {
  navigation,
  mobileStickyNav,
  inlineVideo,
  faqAccordion,
  logoWallCarousel,
};

// globals to window
window.spirax = spirax;

// run the code.
document.addEventListener('DOMContentLoaded', () => {
  Object.keys(spirax).forEach((module) => {
    if (typeof spirax[module].init === 'function') {
      try {
        spirax[module].init();
      } catch (error) {
        console.error(error);
      }
    }
  });
});
